module.exports = __webpack_public_path__ + "img/lander-action-01-mobile.d4fe11a0.webp";